export const CONFIG_ROUTES = {
  index: {
    path: 'config/*',
    to: '/config/sites-and-locations',
  },
  sitesAndLocations: {
    path: '/sites-and-locations',
    to: '/config/sites-and-locations',
  },
  areasAndZones: {
    path: 'station-config/areas-and-zones',
    to: '/config/station-config/areas-and-zones',
  },
  controllers: {
    path: 'station-config/controllers',
    to: '/config/station-config/controllers',
  },
  pipes: {
    path: '/pipes',
    to: '/config/pipes',
  },
  pumps: {
    path: '/pumps',
    to: '/config/pumps',
  },
  plants: {
    path: '/plants',
    to: '/config/plants',
  },
  alert: {
    path: '/alert',
    to: '/config/alert',
  },
  soil: {
    path: '/soil',
    to: '/config/soil',
  },
  etReference: {
    path: '/etReference',
    to: '/config/etReference',
  },
  emitter: {
    path: '/emitter',
    to: '/config/emitter',
  },
  sensors: {
    path: '/sensors',
    to: '/config/sensors',
  },
  etz: {
    path: 'sensors/etz',
    to: '/config/sensors/etz',
  },
  stations: {
    path: 'station-config/stations',
    to: '/config/station-config/stations',
  },
  dataConfig: {
    path: '/dataConfiguration',
    to: '/config/dataConfiguration',
  },
  fertigation: {
    path: '/fertigation/:pipeId',
    to: '/config/fertigation/:pipeId',
  },
  hydraulic: {
    path: '/hydraulic',
    to: '/config/hydraulic',
  },
  hydraulicRule: {
    path: '/hydraulic/:pipeId',
    to: '/config/hydraulic',
  },
}
